import React, { useEffect, useState } from 'react';
import { LoaderCircle } from 'lucide-react';
import logo from '../routes/logo.svg';
import './request-loading.css';
export default function RequestLoading({message='Loading required data…',error,branded=false}:{message?:string;error?:string;branded?:boolean}) {
 const [slow, setSlow] = useState(false);
 useEffect(() => { setSlow(false); if (error) return; const timer = setTimeout(() => setSlow(true), 6000); return () => clearTimeout(timer); }, [message, error]);
 return <section className={branded?'request-loading request-loading--brand':'request-loading'} aria-busy={!error}>
  {branded&&<div className="request-loading-brand"><img src={logo} alt=""/><strong>AgriWorks LMS</strong></div>}
  <p role={error?'alert':'status'}>{!error&&<LoaderCircle className="request-loading-spinner" aria-hidden="true"/>}{error||message}</p>
  {slow && !error && <p role="status">This is taking longer than usual. Please keep this page open while we load your information.</p>}
 </section>;
}
